import { Card, Form, InputNumber, Typography } from 'antd';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateLaborTab } from '../../../../../contextRedux/PMAdditionalActContractProject/PmAdditionalActContractProjectModel';
import { RootState } from '../../../../../store';
import DevicesTable from './DevicesTable/DevicesTable';
import './LaborTab.css';
import LaborTable from './LaborTable/LaborTable';

const { Title, Text } = Typography;

const LaborTab: React.FC<any> = ({}) => {
  const dispatch = useDispatch();
  const pmAdditionalActContractProject = useSelector(
    (state: RootState) => state?.models?.pmAdditionalActContractProject
  );

  const handleLaborPriceChange = (value: number | null) => {
    if (value !== null) {
      dispatch(updateLaborTab({ field: 'laborPriceOnHour', value: value ?? 300 }));
    }
  };

  return (
    <div className='labor-tab-container'>
      <Card className='estimate-card'>
        <Title level={4} className='section-title'>
          Costuri estimate
        </Title>
        <div className='labor-price-container'>
          <Form.Item
            label={<Text strong>Preț manoperă per oră</Text>}
            name='laborPriceOnHour'
            className='labor-price-form-item'
          >
            <InputNumber
              placeholder='Ex: 300'
              value={pmAdditionalActContractProject.laborTab.laborPriceOnHour ?? 300}
              onChange={handleLaborPriceChange}
              addonAfter='lei/oră'
              className='labor-price-input'
              min={1}
            />
          </Form.Item>
          <Text type='secondary' className='labor-price-hint'>
            Acest preț va fi folosit pentru calculul manoperei pe oră pentru toate dispozitivele.
          </Text>
        </div>
      </Card>

      <div className='section-container'>
        <Title level={4} className='section-title'>
          Dispozitive și Manoperă
        </Title>
        <DevicesTable />
      </div>

      <div className='section-container'>
        <Title level={4} className='section-title'>
          Manoperă Suplimentară
        </Title>
        <LaborTable key={'id'} />
      </div>
    </div>
  );
};

export default LaborTab;
